import { get } from "../common/remote/base_api";

export const Getsettlementsres = (franchise_id,franchise_name) => {
  return get(`admin/get-franchise-dues/`, { franchise_id: franchise_id ,franchise_name:franchise_name});
};
